export default __webpack_public_path__ + "static/media/003-fish.40eea8f7.svg";